import React from 'react';

const faqs = [
  {
    question: "What makes a good fantasy football team name?",
    answer: "A good fantasy football team name should be creative, memorable, and ideally incorporate elements like player names, football terminology, or pop culture references. It should also be appropriate for your league's atmosphere."
  },
  {
    question: "How often should I change my fantasy team name?",
    answer: "While some managers keep the same name for years, others change seasonally or even mid-season based on player performance or current events. It's entirely up to you, but keeping it fresh can add extra fun to the league."
  },
  {
    question: "Can I use player names in my team name?",
    answer: "Yes! Using player names in puns or creative combinations is a popular way to create fantasy team names. Just ensure the references are current and clever."
  },
  {
    question: "Should my team name be funny or serious?",
    answer: "Most fantasy football team names tend to be humorous, but it depends on your league's style. Funny names are great for casual leagues, while more competitive leagues might prefer serious or intimidating names."
  },
  {
    question: "How do I make my team name stand out?",
    answer: "Be original, avoid overused puns, and try to combine multiple elements (like a player name with a movie title). Our generator helps by creating unique combinations you might not think of."
  },
  {
    question: "Are there any names I should avoid?",
    answer: "Yes, avoid offensive, inappropriate, or potentially controversial names. Keep it fun and respectful to ensure everyone in your league can enjoy the humor."
  }
];

export default function FantasyFootballFAQ() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          Fantasy Football Team Names FAQ
        </h2>
        
        <div className="space-y-8">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-green-50 p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {faq.question}
              </h3>
              <p className="text-gray-600">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}